import { type ReactNode } from 'react';
import { IconTile, type IconTileProps } from '@/shared/components';
import { I, type IconName } from '@/shared/icons';
import { cn } from '@/shared/lib/cn';

interface SectionCardProps {
  icon: IconName;
  title: string;
  tint?: IconTileProps['variant'];
  trailing?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** Karte des Buchungs-Arbeitsraums (Baukasten): Titel mit Symbol, rechts optional Pill oder Aktion. */
export function SectionCard({
  icon,
  title,
  tint = 'muted',
  trailing,
  className,
  children,
}: SectionCardProps) {
  return (
    <section
      className={cn(
        'border-hairline rounded-tile flex flex-col gap-3 border bg-white p-5',
        className,
      )}
    >
      <div className="flex items-center gap-2.5">
        <IconTile variant={tint} size="sm">
          <I name={icon} size={14} />
        </IconTile>
        <h2 className="font-serif text-lg font-bold tracking-[-0.01em]">{title}</h2>
        {trailing && <div className="ml-auto">{trailing}</div>}
      </div>
      {children}
    </section>
  );
}
